import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// tailwind-merge kennt nur Tailwinds Standardgrößen (text-sm, text-lg, …). Die Typo-Skala der
// Website (tailwind.config.ts, fontSize; Guideline 1.1) heißt text-display/-headline/-title/
// -body/-small/-label; ohne diese Erweiterung hält twMerge sie für TEXTFARBEN. Folge (gemessen
// 21.09.2026): cn("text-sm", "text-label") ließ text-label fallen, cn("text-white", "text-body")
// die Farbe. Hier als Schriftgrößen-Gruppe angemeldet, damit sie sich gegenseitig und die
// Standardgrößen korrekt ersetzen und Farben unangetastet lassen.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [{ text: ["display", "headline", "title", "body", "small", "label"] }],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
